import { apiClient } from './client';
import { normalizeCollectionResponse, normalizeObjectResponse } from '../utils/apiResponse';

export async function getMafertAppModules(params = {}) {
  const { data } = await apiClient.get('/api/system/mafertapp-modules', { params });
  return normalizeCollectionResponse(data);
}

export async function getMafertAppModule(id) {
  const { data } = await apiClient.get(`/api/system/mafertapp-modules/${id}`);
  return normalizeObjectResponse(data);
}

export async function getMafertAppModulePermissions(id) {
  const { data } = await apiClient.get(`/api/system/mafertapp-modules/${id}/permissions`);
  return normalizeCollectionResponse(data);
}

export async function getMafertAppModuleSeedPolicy(id) {
  const { data } = await apiClient.get(`/api/system/mafertapp-modules/${id}/seed-policy`);
  return normalizeObjectResponse(data);
}

export async function getTenantModuleAccessSummary(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/module-access-summary`);
  return normalizeObjectResponse(data);
}

export async function getCustomerPortalTenantModules(customerId, tenantId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/tenants/${tenantId}/modules`);
  return normalizeObjectResponse(data);
}
